import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN"; // lang i18n
import "./assets/css/element-variables.scss";

Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });
import "./assets/css/reset.scss";

import IconSvg from "@/components/icon-svg";
Vue.component("icon-svg", IconSvg);

import md5 from "js-md5";
Vue.prototype.$md5 = md5;

import axios from "@/utils/request";
Vue.prototype.$ajax = axios;
//调接口服务器地址
Vue.prototype.$apihost = process.env.VUE_APP_BASE_URL;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
